import {InvoiceModeCd} from '../';
import {EnumHelper} from './enum-helper';

export class InvoiceModeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in InvoiceModeCd ) {
      this._values.push(InvoiceModeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): InvoiceModeCd {

    for ( const obj in InvoiceModeCd ) {
      if (InvoiceModeCd[obj] === value){
        return InvoiceModeCd[obj] as InvoiceModeCd;
      }
    }
  }
}

const InvoiceModeCdHelper = new InvoiceModeCdHelperEnumHelperClass();
export default InvoiceModeCdHelper;
